import { render } from "./SearchStep.vue?vue&type=template&id=04809953&scoped=true"
import script from "./SearchStep.vue?vue&type=script&lang=js"
export * from "./SearchStep.vue?vue&type=script&lang=js"

import "./SearchStep.vue?vue&type=style&index=0&id=04809953&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04809953"

export default script